import { CommonModule } from '@angular/common';
import { Component, DOCUMENT, ElementRef, OnInit, Renderer2, computed, effect, inject, input, output, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FilterSelection } from 'src/app/components/filters/filters.component';
import { CategoryLayoutType, DynamicPage } from 'src/app/core/enums/dynamic-page.enum';
import { CategoryLayoutData } from 'src/app/core/interfaces/store-configuration.interface';
import { DropdownItem } from 'src/app/core/models/dropdown.model';
import { DeviceDetectionService } from 'src/app/core/services/device-detection/device-detection.service';
import { OverlayService } from 'src/app/core/services/overlay/overlay.service';
import { createDefaultCategoryLayoutData } from 'src/app/core/utilities/type-defaults.util';
import { MappedFilter } from 'src/app/products/services/filters-adapter.service';
import { LinkHandler } from 'src/app/shared/class/link-handler.class';
import { BannerType, MOBILE_GRID_LAYOUT, PaginationType } from '../../enum/category-page.enum';
import { GridViewLayout, SortingLayout1Component } from '../sorting-layout-1/sorting-layout-1.component';

import { ProductListingHit } from 'src/app/products/models/product-listing.model';

import { ListingLoaderComponent } from "src/app/components/listing-loader/listing-loader.component";
import { BrowserApiService } from 'src/app/core/services/browser-api/browser-api.service';
import { CategoryFilterLayout1Component } from "../category-filter-layout-1/category-filter-layout-1.component";
import { CategoryPageShimmerComponent } from "../category-page-shimmer/category-page-shimmer.component";
import { ListingEmptyStateComponent } from "../listing-empty-state/listing-empty-state.component";
import { PaginationLayout1Component } from "../pagination-layout-1/pagination-layout-1.component";
import { ProductCardRectangularComponent } from "../product-card-rectangular/product-card-rectangular.component";
import { ProductCardSquareComponent } from "../product-card-square/product-card-square.component";
@Component({
  standalone: true,
  selector: 'app-category-page-layout-1',
  templateUrl: './category-page-layout-1.component.html',
  styleUrls: ['./category-page-layout-1.component.scss'],
  imports: [CommonModule, RouterModule, CategoryPageShimmerComponent, ListingEmptyStateComponent, ProductCardRectangularComponent, PaginationLayout1Component, ListingLoaderComponent, ProductCardSquareComponent, SortingLayout1Component, CategoryFilterLayout1Component]
})
export class CategoryPageLayout1Component extends LinkHandler implements OnInit {
  public override renderer = inject(Renderer2);
  public override elementRef = inject(ElementRef);
  public override router = inject(Router);
  public override overlayService = inject(OverlayService);
  public override browserApiService = inject(BrowserApiService);
  private document = inject<Document>(DOCUMENT);
  private readonly deviceDetectionService = inject(DeviceDetectionService);

  BannerType = BannerType;



  readonly category = input<string>('');
  readonly availableFilterAttributes = input<MappedFilter[]>([]);
  readonly currentAppliedFilters = input<FilterSelection[]>([]);
  readonly products = input<ProductListingHit[]>([]);
  readonly totalProductsCount = input<number>(0);
  readonly fetchedProductsCount = input<number>(0);
  readonly pageLoading = input<boolean>(false);
  readonly productLoading = input<boolean>(false);
  readonly listLoading = input<boolean>(false);
  readonly paginationOptions = input<DropdownItem<number>[] | null>(null);
  readonly paginationType = input<PaginationType>(PaginationType.PAGE);
  readonly currentPage = input<number>(1);
  readonly sortOptions = input<DropdownItem<string>[]>([]);
  readonly categoryLayoutData = input<CategoryLayoutData>(createDefaultCategoryLayoutData());
  readonly sortBy = input<string>('');
  readonly sortByChange$ = output<string>();
  readonly selectedGridViewLayout = input<string>("");
  readonly selectedGridViewLayoutChange$ = output<string>();

  // Internal state for grid view layout (like the original approach)
  private internalGridViewLayout = signal<string>("");

  // Computed signal that returns the current grid view layout
  readonly currentGridViewLayout = computed(() => {
    const internalValue = this.internalGridViewLayout();
    return internalValue || GridViewLayout.GRID_VIEW_LAYOUT2;
  });

  override readonly page = input<DynamicPage>(DynamicPage.CATEGORY);
  readonly searchValue = input<string>('');
  readonly selectedMobileGridLayout = input<MOBILE_GRID_LAYOUT>(MOBILE_GRID_LAYOUT.GRID_LAYOUT1);

  // Expose device detection service signals for template usage
  readonly isMobile = this.deviceDetectionService.isMobile;
  readonly isDesktop = this.deviceDetectionService.isDesktop;
  readonly isTablet = this.deviceDetectionService.isTablet;
  readonly deviceType = this.deviceDetectionService.deviceType;

  PaginationType = PaginationType;
  gridViewLayout = GridViewLayout;
  mobileFilterOpened = false;
  DynamicPage = DynamicPage;
  CategoryLayoutType = CategoryLayoutType;

  constructor() {
    super();

    // Initialize internal state from input
    effect(() => {
      const inputValue = this.selectedGridViewLayout();
      if (inputValue) {
        this.internalGridViewLayout.set(inputValue);
      }
    });
  }
  ngOnInit(): void {
    this.applyCategoryThemeStyle()
  }

  changeGridViewLayout(gridViewLayout: GridViewLayout) {
    // Update internal state (like the original approach)
    this.internalGridViewLayout.set(gridViewLayout);
  }

  onSortByChange(sortValue: string) {
    this.sortByChange$.emit(sortValue);
  }

  applyCategoryThemeStyle() {
    const categoryThemeContainer = this.document?.getElementsByClassName("dynamic-listing-page-theme")[0];
    const categoryLayoutData = this.categoryLayoutData();

    if (categoryLayoutData.categoryLayoutConfig?.themeBackgroundColor && categoryThemeContainer) {
      this.renderer.setStyle(categoryThemeContainer, 'background-color', categoryLayoutData.categoryLayoutConfig?.themeBackgroundColor)
    }

    if (categoryLayoutData.categoryLayoutConfig?.themeFontFamily && categoryThemeContainer) {
      this.renderer.setStyle(categoryThemeContainer, 'font-family', categoryLayoutData.categoryLayoutConfig?.themeFontFamily);
    }
  }


}
